import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";

export const SectionSix = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const [activeTab, setActiveTab] = useState("shipping");

  // Images for each tab
  const images: Record<string, string> = {
    shipping: "assets/images/checkout-v-one/gmv1.png",
    payment: "assets/images/checkout-v-one/gmv2.png",
    recovery: "assets/images/checkout-v-one/gmv3.png",
  };

  // List items for each tab
  const tabContent: Record<string, string[]> = {
    shipping: [
      "Pincode-level rules",
      "Order-range-based methods",
      "Static EDD support"
    ],
    payment: [
      "UPI, Credit/Debit Cards, Net Banking, COD",
      "Buy Now, Pay Later — Snapmint, Simpl",
      "No Cost EMI + Instant Discounts",
      "All major bank offers supported",
    ],
    recovery: [
      "Automated WhatsApp flows",
      "Higher open & recovery rates",
      "Boost repeat purchases",
    ],
  };

  return (
    <div className="section-six-checkout">
      <div className="container-fluid">
        <div
          className="mid-text3-sec-two w-full md:w-6 mt-10"
          style={{ margin: isMobile ? "0px 0.2rem" : "0px 5rem" }}
        >
          <h1>D2C Merchants are Talking!</h1>
          <p style={{ color: "#fff" }}>They ❤ KwikCheckout</p>
        </div>

        <div className="i" style={{ marginTop:isMobile ? "40px":"90px", maxWidth: "100%" }}>
          {isMobile ? (
            <div>
              <img
                style={{ maxWidth: "95%", transform: "rotate(6deg)" }}
                src="assets/images/checkout-v-one/note1.png"
                alt=""
              />
              <img
                style={{ maxWidth: "90%" }}
                src="assets/images/checkout-v-one/note2.png"
                alt=""
              />
              <img
                style={{ maxWidth: "95%", transform: "rotate(-8deg)" }}
                src="assets/images/checkout-v-one/note3.png"
                alt=""
              />
            </div>
          ) : (
            <img
              style={{ maxWidth: "80%" }}
              src="assets/images/checkout-v-one/merchant-talk.png"
              alt=""
            />
          )}
        </div>

        <div className="section-six-a-container">
          <h1>Power up Your Checkout.</h1>
          <h1>Multiply GMV</h1>

          <div className="flex gap-10 mt-10 sec-div-gvm">
            {/* Left side dropdowns */}
            <div className="w-1/2">
          
              {/* Shipping Tab */}
              <div
                className={`dropdown-checkout ${
                  activeTab === "shipping" ? "active" : ""
                }`}
                onClick={() => setActiveTab("shipping")}
                style={{ transition: "max-height 0.35s cubic-bezier(0.4, 0, 0.2, 1)",}}
              >
                <div className="flex items-center"  style={{justifyContent:"space-between"}}>
                  <h3>
                    Optimize Shipping Rules
                  </h3>
                  {activeTab === "shipping" ? (
                    <IoIosArrowUp size={isMobile ? 18 :22 } color="#5033FF" />
                  ) : (
                    <IoIosArrowDown size={isMobile ? 18 :22 } color="#38485C" />
                  )}
                </div>

                {activeTab === "shipping" && (
                  <div>
                    <h4>
                      Set fees & methods based on cart value, payment type, or pincode — no code required.
                    </h4>
                    {tabContent.shipping.map((item, idx) => (
                      <div
                        key={idx}
                        className="flex gap-2"
                        style={{ alignItems: "flex-start" }}
                      >
                        <img
                          style={{ marginTop: "4px" }}
                          src="/assets/images/checkout-v-one/check.svg"
                          alt="checkmark"
                        />
                        <p>{item}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              {/* Payment Tab */}
              <div
                className={`dropdown-checkout ${
                  activeTab === "payment" ? "active" : ""
                }`}
                onClick={() => setActiveTab("payment")}
              >
                <div className="flex items-center" style={{justifyContent:"space-between"}}>
                  <h3 >
                    Flexible Payment Options
                  </h3>
                  {activeTab === "payment" ? (
                    <IoIosArrowUp size={22} color="#5033FF" />
                  ) : (
                    <IoIosArrowDown size={22} color="#38485C" />
                  )}
                </div>

                {activeTab === "payment" && (
                  <div>
                    <h4 style={{ fontSize: "18px", color: "#111",minWidth:'440px' }}>
                      From UPI to No Cost EMI, support every mode that converts.
                    </h4>
                    {tabContent.payment.map((item, idx) => (
                      <div
                        key={idx}
                        className="flex gap-2"
                        style={{ alignItems: "flex-start" }}
                      >
                        <img
                          style={{ marginTop: "4px" }}
                          src="/assets/images/checkout-v-one/check.svg"
                          alt="checkmark"
                        />
                        <p>{item}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              {/* Recovery Tab */}
              <div
                className={`dropdown-checkout ${
                  activeTab === "recovery" ? "active" : ""
                }`}
                onClick={() => setActiveTab("recovery")}
              >
                <div className="flex items-center" style={{justifyContent:"space-between"}}>
                  <h3 style={{ fontSize: "21px", color: "#38485C" }}>
                    Automate Cart Recovery
                  </h3>
                  {activeTab === "recovery" ? (
                    <IoIosArrowUp size={22} color="#5033FF" />
                  ) : (
                    <IoIosArrowDown size={22} color="#38485C" />
                  )}
                </div>

                {activeTab === "recovery" && (
                  <div>
                    <h4 style={{ fontSize: "18px", color: "#111" }}>
                    With KwikEngage, send automated cart reminders on WhatsApp and boost conversions.
                    </h4>
                    {tabContent.recovery.map((item, idx) => (
                      <div
                        key={idx}
                        className="flex gap-2"
                        style={{ alignItems: "flex-start" }}
                      >
                        <img
                          style={{ marginTop: "4px" }}
                          src="/assets/images/checkout-v-one/check.svg"
                          alt="checkmark"
                        />
                        <p>{item}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* Right side image */}
            <div className="w-1/2" style={{ width: "100%" }}>
              <img
                style={{ width: "715px", }}
                src={images[activeTab]}
                alt={activeTab}
                
                className="rounded-xl transition-all duration-800"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionSix;
